import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { ProduzioneFileDigitale } from "../types"
import { API_URL } from "../constants"

export function useProduzioniFileDigitaliList(params: Record<string, string> = {}) {
  return useList<ProduzioneFileDigitale>(`${API_URL}/produzioni-files-digitali`, {
    query: params,
  })
}

export function useProduzioneFileDigitaleDetail(id: number | undefined | string) {
  return useDetail<ProduzioneFileDigitale>(`${API_URL}/produzioni-files-digitali`, id?.toString())
}

export function useProduzioneFileDigitaleCreate() {
  return useCreate<ProduzioneFileDigitale>(`${API_URL}/produzioni-files-digitali`)
}

export function useProduzioneFileDigitaleUpdate() {
  return useUpdate<ProduzioneFileDigitale>(`${API_URL}/produzioni-files-digitali`)
}

export function useProduzioneFileDigitaleDelete() {
  return useDelete<ProduzioneFileDigitale>(`${API_URL}/produzioni-files-digitali`)
}
